import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { auth, db } from '@/firebase'
import { doc, getDoc } from 'firebase/firestore'

Vue.config.productionTip = false

Vue.prototype.$goToProfile = async function () {
  const userAuth = auth.currentUser;
  if (!userAuth) {
    this.$router.push('/');
    return;
  }

  const userRef = doc(db, 'user', userAuth.uid);
  const userSnapshot = await getDoc(userRef);

  if (userSnapshot.exists()) {
    const user = userSnapshot.data();
    const role = user.role;
    const uid = userAuth.uid;

    if (role === 'Admin') {
      this.$router.push('/admin-settings');
    } else {
      this.$router.push({ name: 'MemberSettings', params: { id: uid } });
    }
  } else {
    console.error('User document not found');
    this.$router.push('/');
  }
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')